import Api from './Api'
import {api} from "../common/jwt.service";

export default {
    signup (credentials){
        return Api().post('user/register', credentials)
    },

    login(credentials){
      return Api().post('user/connect', credentials)
    },

    brevoSaveContact(credentials) {
        return Api().post('brevo/create/contact', credentials)
    },

    // Selectionne l'utilisateur connecté
    userProfile(id) {
        return Api().get('user/'+id)
    },
    userUpdate(id, userparam){
        return api().put('user/update/'+id, userparam)
    }

}